import React from 'react'
import Helmet from 'react-helmet'
import PropTypes from 'prop-types'

const NestedReviewsSchema = ({ itemReviewed, nestedReviews }) =>
  <Helmet>
    <script type="application/ld+json">
      {
        JSON.stringify({
          context: 'https://schema.org',
          '@type': 'Review',
          itemReviewed,
          review: nestedReviews
        })
      }
    </script>
  </Helmet>

export default NestedReviewsSchema

NestedReviewsSchema.propTypes = {
  itemReviewed: PropTypes.shape(),
  nestedReviews: PropTypes.arrayOf(PropTypes.shape())
}
